import { render, staticRenderFns } from "./HrSalarySettlementCreate.vue?vue&type=template&id=3129680c&lang=pug&"
import script from "./HrSalarySettlementCreate.vue?vue&type=script&lang=js&"
export * from "./HrSalarySettlementCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HrSalarySettlementCreate.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {
  VBtn,
})
